import Mock from "mockjs";
Mock.setup({
  timeout: '200-600'
})
const files = require.context("./modules", false, /.js$/);
files.keys().forEach(key => {
  files(key).default.forEach(value => {
    Mock.mock(value.url, value.type || "post", value.response);
  });
});
